import { enumManagers } from '@chirp/enums';
import moment from 'moment-timezone';

export const USER_TIMEZONE_VALUE = moment.tz.guess();
export const USER_TIMEZONE_ABBR = moment.tz(USER_TIMEZONE_VALUE).zoneAbbr();

// Currently only supports US timezones (excluding Alaska and Hawaii)
const systemTimezoneOptions = enumManagers.Timezone.getOptions()
  .map(({ label, value }) => ({ label, value })); // Remove index field

const foundUserTimezone = systemTimezoneOptions.find(t => t.value === USER_TIMEZONE_VALUE);

export const USER_TIMEZONE_LABEL = foundUserTimezone?.label || (
  // If user timezone is not one of system timezones, create custom label
  `${USER_TIMEZONE_VALUE} (${USER_TIMEZONE_ABBR})` // e.g., Asia/Kolkata (IST)
);

const USER_TIMEZONE_SELECT_OPTIONS = [...systemTimezoneOptions];

if (!foundUserTimezone) {
  // If user timezone is not one of system timezones, add to list of select options
  USER_TIMEZONE_SELECT_OPTIONS.unshift({
    value: USER_TIMEZONE_VALUE,
    label: USER_TIMEZONE_LABEL,
  });
}

export { USER_TIMEZONE_SELECT_OPTIONS };
